module.exports = __webpack_public_path__ + "static/media/battery.c42ef986.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/battery.svg
// module id = 479
// module chunks = 0